import { apiFetch, ApiError } from '@/lib/http';

export type RemoveAccessResult = 'removed' | 'already-gone';

/**
 * Remove the current user's own access to a shared entity.
 *
 * 403 and 404 are not failures: they mean the access was already gone — a
 * double-click, or an owner who revoked concurrently. The desired outcome
 * holds either way, so callers refresh rather than showing an error.
 */
export async function removeMyAccess(entityId: string): Promise<RemoveAccessResult> {
  try {
    await apiFetch<void>(`/entities/${entityId}/access/me`, { method: 'DELETE' });
    return 'removed';
  } catch (err) {
    if (err instanceof ApiError && (err.status === 403 || err.status === 404)) {
      return 'already-gone';
    }
    throw err;
  }
}
